import React, { useEffect, useState } from "react";
import { Fade, Grow, makeStyles } from "@material-ui/core";
import { Link } from 'react-router-dom';


let useStyles = makeStyles((theme) => ({
    bgSubmenu: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "stretch",
        minWidth: 200,
        minHeight: "auto",
        padding: 15,
        position: "relative",
        top: 10,
        borderRadius: 10,
        backgroundColor: " #fff",
        boxShadow: "0px 4px 11px 0px rgba(0, 0, 0, 0.15)",
    },
    gridSubmenu: {
        position: "absolute",
        zIndex: 100,
        minHeight: "auto",
        padding: "20px 20px 20px 0px ",
        transition: "all 0.3s linear",
    },
    subMenu: {
        display: "block",
        width: "100%",
        marginBottom: 4,
        '&:last-child': {
            marginBottom: 0,
        },
        '& > li': {
            padding: "7px 7px",
            margin: "2px 2px",
            fontWeight: "bold",
            '& > a': {
                whiteSpace: 'nowrap'
            },
        },
    },
    titleSubmenu: {
        // borderBottom: "1px solid #dbd9d9",
        fontSize: 14,
        color: 'rgba(0,0,0,0.4)',
        fontWeight: '300 !important',
        marginBottom: "10px !important",

    },
    descSubMenu: {
        '& a': {
            width: "100%",
            color: "black",
            cursor: "pointer",
            padding: "1px 4px",
            fontSize: ".825rem",
            borderRadius: " 4px",
            fontWeight: 400,
            fontSize: 14,
            whiteSpace: "nowrap",
            textDecoration: "none",
            display: "block",
        },
        '&:hover': {
            color: '#E60001 !important'
        },
    },
    badge: {
        background: "#DDE0FF",
        display: 'inline-block',
        padding: "5px 10px ",
        borderRadius: 20,
        fontSize: 10,
        marginLeft: 5,
        color: '#5A68B2'
    },
    title: {
        color: 'black',
        fontWeight: 400,
        fontSize: 14,
        '&:hover': {
            // backgroundColor: "#f2f2f2",
            color: '#E60001 !important'

        },

    },
    animationList: {
        "-webkit-animation": ` slidein 1s ease`,
        "-moz-animation": ` slidein 1s ease`,
        "-o-animation": ` slidein 1s ease`,
        animation: ` slidein 1s ease`,
    }
}))

export default function Index({ item, flagHeader, ind, home, IndexMenu }) {

    let classes = useStyles();


    return (
        <>
            {
                <ul >
                    <li key={ind} style={{ zIndex: 5 }}>
                        <p to={item.route} className={`m-0 titleRed ${classes['title']}`} style={{ color: home ? "white" : flagHeader ? 'white' : '' }}>
                            {item.label}
                        </p>
                        <div className={`${classes['gridSubmenu']} ${classes['animationList']}`} >
                            <div className={classes['bgSubmenu']}>
                                <>
                                    {
                                        (item.child || []).map((subItem, subInd) => (
                                            <ul key={subInd} className={classes['subMenu']}>
                                                {subItem.child?.length > 0 ? (
                                                    <>
                                                        {
                                                            subItem.label && (
                                                                <li style={{ zIndex: 5 }} className={`${classes['titleSubmenu']}`}>
                                                                    {subItem.label}
                                                                </li>
                                                            )
                                                        }
                                                        {
                                                            (subItem.child || []).map((leafItem, leafInd) => (
                                                                <li key={leafInd} style={{ zIndex: 5 }} className={classes['descSubMenu']}>
                                                                    {
                                                                        leafItem.route?.slice(0, 4) === "http" ?
                                                                            <a target="_blank" rel="noopener noreferrer" href={leafItem.route} >
                                                                                {leafItem.label}
                                                                                {
                                                                                    leafItem?.badge?.title && (
                                                                                        <span className={classes['badge']}>
                                                                                            {leafItem?.badge?.title}
                                                                                        </span>
                                                                                    )
                                                                                }
                                                                            </a>
                                                                            :
                                                                            leafItem?.action
                                                                                ? (
                                                                                    <span  className={`${classes['title']}`} onClick={()=> leafItem?.action()} style={{cursor:'pointer'}}>
                                                                                        {leafItem.label}
                                                                                    </span>
                                                                                )
                                                                                :
                                                                                    <Link to={leafItem.route || '#'} >
                                                                                        {leafItem.label}
                                                                                        {
                                                                                            leafItem?.badge?.title && (
                                                                                                <span className={classes['badge']}>
                                                                                                    {leafItem?.badge?.title}
                                                                                                </span>
                                                                                            )
                                                                                        }
                                                                                    </Link>
                                                                    }
                                                                </li>
                                                            ))
                                                        }
                                                    </>
                                                ) : subItem.route ? (
                                                    <li style={{ zIndex: 5 }} className={classes['descSubMenu']}>
                                                        {
                                                            subItem.route?.slice(0, 4) === "http" ? (
                                                                <a target="_blank" rel="noopener noreferrer" href={subItem.route}>
                                                                    {subItem.label}
                                                                    {subItem?.badge?.title && (
                                                                        <span className={classes['badge']}>{subItem?.badge?.title}</span>
                                                                    )}
                                                                </a>
                                                            ) : subItem?.action ? (
                                                                <span className={`${classes['title']}`} onClick={() => subItem?.action()} style={{ cursor: 'pointer' }}>
                                                                    {subItem.label}
                                                                </span>
                                                            ) : (
                                                                <Link to={subItem.route || '#'}>
                                                                    {subItem.label}
                                                                    {subItem?.badge?.title && (
                                                                        <span className={classes['badge']}>{subItem?.badge?.title}</span>
                                                                    )}
                                                                </Link>
                                                            )
                                                        }
                                                    </li>
                                                ) : subItem.label ? (
                                                    <li style={{ zIndex: 5 }} className={classes['titleSubmenu']}>
                                                        {subItem.label}
                                                    </li>
                                                ) : null}
                                            </ul>
                                        ))
                                    }
                                </>
                            </div>
                        </div>
                    </li>
                </ul>
            }


        </>
    )
}
